import * as i0 from '@angular/core';
import { booleanAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';
import { ObjectUtils } from 'primeng/utils';
const _c0 = ["*"];
let BaseIcon = /*#__PURE__*/(() => {
  class BaseIcon {
    label;
    spin = false;
    styleClass;
    role;
    ariaLabel;
    ariaHidden;
    ngOnInit() {
      this.getAttributes();
    }
    getAttributes() {
      const isLabelEmpty = ObjectUtils.isEmpty(this.label);
      this.role = !isLabelEmpty ? 'img' : undefined;
      this.ariaLabel = !isLabelEmpty ? this.label : undefined;
      this.ariaHidden = isLabelEmpty;
    }
    getClassNames() {
      return `p-icon ${this.styleClass ? this.styleClass + ' ' : ''}${this.spin ? 'p-icon-spin' : ''}`;
    }
    static ɵfac = function BaseIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BaseIcon)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BaseIcon,
      selectors: [["ng-component"]],
      hostAttrs: [1, "p-element", "p-icon-wrapper"],
      inputs: {
        label: "label",
        spin: [2, "spin", "spin", booleanAttribute],
        styleClass: "styleClass"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BaseIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return BaseIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BaseIcon };
